import { render, staticRenderFns } from "./addUpdateAgent.vue?vue&type=template&id=58ddcee1&scoped=true"
import script from "./addUpdateAgent.vue?vue&type=script&lang=js"
export * from "./addUpdateAgent.vue?vue&type=script&lang=js"
import style0 from "./addUpdateAgent.vue?vue&type=style&index=0&id=58ddcee1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ddcee1",
  null
  
)

export default component.exports